import { isPersistedDomainStore } from '../storage/types/domain-store';
import { browsingDomainStore } from './browsing/store';
import { temporaryBrowsingDomainStore } from './browsing/temporary-store/store';
import { filterDomainStore } from './filter/store';
import { temporaryGiftCardDomainStore } from './gift-card/store';
import { journeyDomainStore } from './journey/store';
import { loyaltyDomainStore } from './loyalty/store';
import { temporaryLoyaltyDomainStore } from './loyalty/temporary-store/store';
import { notificationDomainStore } from './notification/store';
import { temporaryNotificationDomainStore } from './notification/temporary-store/store';
import { orderDomainStore } from './order/store';
import { temporaryOrderDomainStore } from './order/temporary-store/store';
import { paymentDomainStore } from './payment/store';
import { salesDataDomainStore } from './sales-data/store';
import { seatingDomainStore } from './seating/store';
import { sessionDomainStore } from './session/store';
export const domainStores = {
    order: orderDomainStore,
    orderTemporary: temporaryOrderDomainStore,
    filter: filterDomainStore,
    giftCardTemporary: temporaryGiftCardDomainStore,
    seating: seatingDomainStore,
    loyalty: loyaltyDomainStore,
    loyaltyTemporary: temporaryLoyaltyDomainStore,
    journey: journeyDomainStore,
    browsing: browsingDomainStore,
    browsingTemporary: temporaryBrowsingDomainStore,
    salesData: salesDataDomainStore,
    session: sessionDomainStore,
    notification: notificationDomainStore,
    notificationTemporary: temporaryNotificationDomainStore,
    payment: paymentDomainStore
};
const domainStoresArray = Object.values(domainStores);
const persistedDomainStores = domainStoresArray.filter(isPersistedDomainStore);
/**
 * Hydrates the data for each persisted domain store, based on the cached state inside local and session storage.
 */
export const hydrateDomainStores = () => persistedDomainStores.forEach(store => store.hydrate());
/**
 * Resets the data in each domain store.
 */
export const resetDomainStores = () => domainStoresArray.forEach(store => store.reset());
//# sourceMappingURL=stores.js.map